import { useAppDispatch } from "app/hooks";
import { uniqBy } from "lodash";
import { fetchCompanySet } from "store/slice/Project/companiesSet/companiesSetSlice";
import { fetchPersonSet } from "store/slice/Project/peopleSet/peopleSetSlice";

const useRequestSet = () => {
    const dispatch = useAppDispatch();

    const requestSets = async (projectId: number, paths: string[], type: "company" | "people") => {
        const promises: any = [];

        if (type === "company") {
            paths.forEach(async (path) => {
                promises.push(dispatch(fetchCompanySet({ projectId, path })));
            });
        } else {
            paths.forEach(async (path) => {
                promises.push(dispatch(fetchPersonSet({ projectId, path })));
            });
        }

        const promisesResults = await Promise.allSettled(promises);
        const results = promisesResults.reduce((acc, result) => {
            return result.status === "fulfilled" ? [...acc, ...result.value.payload.children] : [];
        }, [] as any[]);
        const data = uniqBy(results, "data.id");

        return data;
    };

    const getCompanySetPath = (projectId: number | string, setId: number | string) =>
        `/project_${projectId}/company_set_list/company_set_${setId}`;

    const getPersonSetPath = (projectId: number | string, setId: number | string) =>
        `/project_${projectId}/person_set_list/person_set_${setId}`;

    return { requestSets, getCompanySetPath, getPersonSetPath };
};

export default useRequestSet;
